import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/OnboardingStep2Page.css';
import { useAuth } from '../context/AuthContext';
import { updateUserBrugernavn } from '../services/userService';

const OnboardingStep2Page: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [brugernavn, setBrugernavn] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const handleNext = async () => {
    if (!brugernavn.trim()) {
      alert('Indtast venligst et brugernavn');
      return;
    }

    if (brugernavn.length > 30) {
      alert('Brugernavn må maksimalt være 30 tegn');
      return;
    }

    if (!currentUser) {
      navigate('/login');
      return;
    }

    try {
      setLoading(true);
      await updateUserBrugernavn(currentUser.uid, brugernavn);
      navigate('/signup-completed');
    } catch (error) {
      console.error('Error saving brugernavn:', error);
      alert('Der opstod en fejl. Prøv venligst igen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="onboarding-step2-page">
      {/* Background Image */}
      <div className="background-image"></div>

      {/* Logo */}
      <img src="/images/logo.png" alt="Wiin Logo" className="onboarding-logo" />

      {/* Title */}
      <h1 className="onboarding-title">Vælg dit brugernavn</h1>

      {/* Username Form */}
      <div className="username-form">
        <div className="form-field">
          <input
            type="text"
            name="brugernavn"
            placeholder="Brugernavn"
            value={brugernavn}
            onChange={(e) => setBrugernavn(e.target.value)}
            maxLength={30}
            required
          />
        </div>
      </div>

      {/* Progress Indicator */}
      <div className="progress-indicator">
        <img src="/images/onboarding_2.png" alt="Step 2 of 3" className="progress-image" />
      </div>

      {/* Next Button */}
      <div className="button-container">
        <button 
          className="next-button" 
          onClick={handleNext}
          disabled={loading || !brugernavn.trim()}
        >
          <span>{loading ? 'Gemmer...' : 'Næste'}</span>
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.67 9.07L23.67 13.35L18.67 17.63"
              stroke="#FFFFFF"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.09 13.35H23.67"
              stroke="#FFFFFF"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep2Page;
